export const ENDPOINTS = {
  COMPLAINTSET: (complaintSet: string = "default"): string =>
    `v4/complaintSets?name=${complaintSet}&firstOccurrenceOnly=true`,
  TEAM: (id: string): string => `v4/emsAgencies/${id}?fields=dynamicForms`,
  HOSPITAL_STATUSES: (id: string): string => `v4/hospitals/${id}/statuses`,
};
